import request from './request'
import * as http from '@/libs/http'

/**
 * クーポンコードの確認を行う
 *
 * @param {Number} shopid 店舗ID
 * @param {Object} data クーポンの確認情報
 * @returns {Response} レスポンスデータ
 */
export function validateCoupon (shopid, data) {
  return request.post(`/shops/${shopid}/coupons`, data, {
    validateStatus: (status) => [
      http.OK,
      http.NotFound,
      http.Forbidden
    ].includes(status)
  })
}
